// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-js .vjs-time-control {
    display: block;
}
.video-js .vjs-remaining-time {
    display: none;
}

.aiiif-audio-player .vjs-big-play-button {
    display: none !important;
}

.aiiif-audio-player .vjs-fullscreen-control {
    display: none !important;
}
.aiiif-audio-player .vjs-control-bar {
    display: flex !important;
}

.aiiif-audio-player {
    height: 72px;
    width: 100%;
}

.aiiif-content-audio {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.aiiif-video-player {
    height: 100%;
    width: 100%;
    min-height: 50%;
}

.aiiif-media-player-container {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.aiiif-content-audio > div:first-of-type {
    min-height: 42px;
}

.video-js {
    font-size: 14px;
}

.vjs-audio {
    min-height: 42px;
}


.aiiif-player-container {
    width: 100%;
}

.aiiif-player-container.aiiif-video {
    height: 100%;
}

.aiiif-player-container > div {
    height: inherit;
}

.aiiif-video-splitter > .aiiif-b {
    position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/viewer/media/media-player.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".video-js .vjs-time-control {\n    display: block;\n}\n.video-js .vjs-remaining-time {\n    display: none;\n}\n\n.aiiif-audio-player .vjs-big-play-button {\n    display: none !important;\n}\n\n.aiiif-audio-player .vjs-fullscreen-control {\n    display: none !important;\n}\n.aiiif-audio-player .vjs-control-bar {\n    display: flex !important;\n}\n\n.aiiif-audio-player {\n    height: 72px;\n    width: 100%;\n}\n\n.aiiif-content-audio {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.aiiif-video-player {\n    height: 100%;\n    width: 100%;\n    min-height: 50%;\n}\n\n.aiiif-media-player-container {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n}\n\n.aiiif-content-audio > div:first-of-type {\n    min-height: 42px;\n}\n\n.video-js {\n    font-size: 14px;\n}\n\n.vjs-audio {\n    min-height: 42px;\n}\n\n\n.aiiif-player-container {\n    width: 100%;\n}\n\n.aiiif-player-container.aiiif-video {\n    height: 100%;\n}\n\n.aiiif-player-container > div {\n    height: inherit;\n}\n\n.aiiif-video-splitter > .aiiif-b {\n    position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
